"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var react_1 = __importDefault(require("react"));
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var ClearButton_1 = require("../ClearButton");
var FloatInput_1 = require("./FloatInput");
var FrameInput_1 = require("./FrameInput");
var LineInput_1 = require("./LineInput");
var variantsMap = (_a = {},
    _a[system_1.InputVariants.Line] = LineInput_1.LineInput,
    _a[system_1.InputVariants.Frame] = FrameInput_1.FrameInput,
    _a[system_1.InputVariants.Float] = FloatInput_1.FloatInput,
    _a);
var useHelperStyles = (0, system_1.makeStyles)(function (theme) { return ({
    root: {},
    error: {
        '$root&': __assign(__assign({}, theme.go.mixins.typography.Caption), { color: theme.go.schemes.colors.system.TextAttention }),
    },
    contained: {
        marginLeft: 0,
        marginRight: 0,
    },
}); });
var useStyles = (0, system_1.makeStyles)({
    inputRoot: {
        width: '100%',
    },
    clearIcon: {
        right: 6,
        position: 'absolute',
        visibility: 'hidden',
        '$inputRoot:hover &': {
            visibility: 'visible',
        },
        '$inputRoot input:focus + &': {
            visibility: 'visible',
        },
        '$inputRoot textarea:focus + &': {
            visibility: 'visible',
        },
    },
    clearIconLine: {
        right: 0,
    },
}, { name: 'GoInput' });
var useLabelStyles = (0, system_1.makeStyles)(function () { return ({
    formControl: {
        transform: 'none',
        position: 'static',
    },
}); });
exports.Input = react_1.default.memo(react_1.default.forwardRef(function Input(_a, ref) {
    var _b, _c;
    var _d = _a.variant, variant = _d === void 0 ? system_1.InputVariants.Line : _d, _e = _a.clearable, clearable = _e === void 0 ? true : _e, onClear = _a.onClear, helperText = _a.helperText, props = __rest(_a, ["variant", "clearable", "onClear", "helperText"]);
    var disabled = props.disabled;
    var _f = useStyles(), inputRoot = _f.inputRoot, clearIcon = _f.clearIcon, clearIconLine = _f.clearIconLine;
    var helperClasses = useHelperStyles();
    var labelClasses = useLabelStyles();
    var endAdornment = clearable && !disabled ? (react_1.default.createElement(InputAdornment_1.default, { position: "end", className: (0, utils_1.cn)(clearIcon, variant === system_1.InputVariants.Line ? clearIconLine : undefined) },
        react_1.default.createElement(ClearButton_1.ClearButton, { onClick: onClear }))) : null;
    var Component = variantsMap[variant];
    return (react_1.default.createElement(Component, __assign({ ref: ref }, props, { autoComplete: "no", className: (0, utils_1.cn)(inputRoot, props.className), InputProps: __assign({ endAdornment: endAdornment }, props.InputProps), inputProps: __assign(__assign({}, props.inputProps), { autoComplete: 'no' }), InputLabelProps: __assign(__assign({}, props.InputLabelProps), { classes: utils_1.cn.merge(labelClasses, (_b = props.InputLabelProps) === null || _b === void 0 ? void 0 : _b.classes) }), FormHelperTextProps: __assign(__assign({}, props.FormHelperTextProps), { classes: utils_1.cn.merge(helperClasses, (_c = props.FormHelperTextProps) === null || _c === void 0 ? void 0 : _c.classes) }), helperText: helperText, clearable: clearable })));
}));
